import React, { useState } from 'react';
import { useLocale } from 'hooks';
import { Grid, Typography } from '@material-ui/core';

import { QRReader, Button } from 'ui';
import { StepContainer } from '../stepContainer/StepContainer';
import { EanIcon, QrIcon } from '../icons';

import { ScanBatteryProps } from './ScanAsset.types';
import { useStyles } from './ScanAsset.styles';

export const ScanAsset = ({
  handleRead,
  goToPreviousStep,
  delayNextScan = false,
  isEan,
  skipInfo,
  goToNextStep,
}: ScanBatteryProps) => {
  const { formatMessage } = useLocale();
  const [step, setStep] = useState(skipInfo ? 1 : 0);
  const classes = useStyles();
  const [isError, setError] = useState(false);

  const renderContent = () => {
    if (step === 0) {
      return (
        <Grid container direction="column" alignItems="center" className={classes.container}>
          {isEan ? <EanIcon className={classes.icon} /> : <QrIcon className={classes.icon} />}
          <Typography className={classes.title}>
            {formatMessage({ id: isEan ? 'ean.before_scan' : 'qr.before_scan' })}
          </Typography>
          <Grid item xs={7} className={classes.confirm}>
            <Button variant="contained" color="primary" onClick={() => setStep(1)}>
              {formatMessage({ id: 'common.continue' })}
            </Button>
          </Grid>
        </Grid>
      );
    }

    return (
      <>
        <QRReader handleError={() => setError(true)} handleRead={handleRead} delayNextScan={delayNextScan} />
        {isError && (
          <Grid style={{ marginTop: 16 }} container spacing={2}>
            <Grid item xs={12}>
              <Typography className={classes.scannerError}>{formatMessage({ id: 'scanner.error' })}</Typography>
              <Button variant="contained" color="primary" onClick={goToNextStep}>
                {formatMessage({ id: 'common.continue' })}
              </Button>
            </Grid>
          </Grid>
        )}
        {goToPreviousStep && (
          <Grid style={{ marginTop: 16 }} container spacing={2}>
            <Grid item xs={12}>
              <Button variant="outlined" color="primary" onClick={goToPreviousStep}>
                {formatMessage({ id: 'common.back' })}
              </Button>
            </Grid>
          </Grid>
        )}
      </>
    );
  };
  return (
    <StepContainer title={formatMessage({ id: step === 0 ? 'issue_battery.before_scan' : 'issue_battery.scan' })}>
      {renderContent()}
    </StepContainer>
  );
};
